// Mirror of supabase/functions/_shared/orderDeadline.ts — update BOTH when extending.
export const ORDER_DEADLINE = "2026-05-20T01:00:00+08:00";
export const HARD_CLOSE_OFFSET_MS = 6 * 60 * 60 * 1000;

export function getOrderDeadline(): Date {
  return new Date(ORDER_DEADLINE);
}

export function getHardCloseTime(): Date {
  return new Date(getOrderDeadline().getTime() + HARD_CLOSE_OFFSET_MS);
}

export function isPastDeadline(now: Date = new Date()): boolean {
  return now.getTime() >= getOrderDeadline().getTime();
}

export function isPastHardClose(now: Date = new Date()): boolean {
  return now.getTime() >= getHardCloseTime().getTime();
}
